<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6">
        <v-file-input
            v-model="fileInfo"
            @change="uploadFile"
            :disabled="loading"
            :loading="loading"
            :label="label"
            chips
            counter
            multiple
            show-size
            dense
            truncate-length="50"
        ></v-file-input>
      </v-col>
    </v-row>
    <v-row v-for="(file, i) in fileList" :key="i">
      <v-col cols="12" sm="3">
        <a :href="file.url">{{file.fileName}}</a>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn text color="primary" small v-if="!file.notCanDel" @click="deleteFile(i)">删除</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {default as ContractApi} from "@/api/erp/contract/ContractApi";

export default {
  name: "FileUpload",
  data(){
    return {
      fileInfo:[],
      loading:false,
    }
  },
  props: {
    value: {
      type: Array,
    },
    label: {
      type: String,
      default :'附件'
    },
  },
  model: {
    prop: 'value',
    event: 'modify',
  },
  computed: {
    fileList: {
      get: function () {
        return this.value //将props中的typeId值赋给value
      },
      set: function (val) {
        this.$emit('modify', val) //通过$emit触发父组件
      },
    },
  },
  methods:{
    uploadFile() {
      let me = this;
      if (this.fileInfo && this.fileInfo.length > 0) {
        this.loading = true;
        let fileNum = 0;
        this.fileInfo.forEach(function (file) {
          ContractApi.uploadFile(file).then(resp => {
            let data = resp.data;
            if (data.code == 200) {
              me.fileList.push({fileName: file.name, url: data.msg, notCanDel: false})
            } else {
              let text = data.errMsg
              me.$dialog.error({
                text: text,
                title: "错误"
              });
            }

            fileNum++;
            if (fileNum == me.fileInfo.length) {
              me.loading = false;
              me.fileInfo = [];
            }
          })
              .catch(error => {
                ContractApi.handleNetworkError(error, me)
              })
        })
      }
    },
    deleteFile(index){
      this.fileList.splice(index,1);
    },
  },

}
</script>

<style scoped>

</style>